import script from "./Item.vue?vue&type=script&setup=true&lang=js"
export * from "./Item.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&lang=css&external"
import "./Item.vue?vue&type=style&index=1&id=3ad16537&lang=css"

const __exports__ = script;

export default __exports__